import { styled } from '@mui/system';
import { Grid } from '@mui/material';

export const fullscreenStyles = {
  height: '100vh',
  position: 'fixed' as const,
  top: 0,
  left: 0,
  width: '100%',
  zIndex: 1000,
  background: '#fff',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column' as const,
  padding: '5px',
  boxSizing: 'border-box' as const,
};

export const normalStyles = {
  display: 'flex',
  flexDirection: 'column' as const,
  height: '100%',
  overflow: 'hidden',
};

export const ToolContainer = styled('div')<{ isFullscreen?: boolean }>(({ isFullscreen }) =>
  isFullscreen ? fullscreenStyles : normalStyles
);

export const NavSection = styled(Grid)({
  flex: '0 0 auto',
});

export const ContentSection = styled(Grid)<{ isFullscreen?: boolean }>(({ isFullscreen }) => ({
  flex: '1 1 auto',
  minHeight: 0,
  ...(isFullscreen ? { height: '100%' } : {}),
}));

export const LeftPanel = styled(Grid)({
  '&&': {
    paddingTop: 0,
  },
  border: '1px solid rgba(0, 0, 0, 0.17)',
  borderRadius: '8px',
  flexDirection: 'row',
  height: '100%',
  minHeight: 0,
});

export const RightPanel = styled(Grid)<{ isFullscreen?: boolean }>(({ isFullscreen }) => ({
  '&&': {
    paddingTop: 0,
  },
  height: '100%',
  minHeight: 0,
}));

export const ContentWrapper = styled('div')({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  boxSizing: 'border-box',
  height: '100%',
  backgroundColor: 'white',
  padding: '10px 40px',
});
